import React, { useState } from "react"
import MetaTags from "react-meta-tags"
import {
  Container,
  Card,
  CardBody,
  CardTitle,
  CardSubtitle,
  CardText,
  CardHeader,
  Collapse,
  Navbar,
  NavbarToggler,
  NavbarBrand,
  Nav,
  NavItem,
  NavLink,
  Button,
  TabContent,
  TabPane,
  Row,
  Col,
  Input,
  Table,
  Alert,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
} from "reactstrap"
import Select from "react-select"
import { Link, useHistory } from "react-router-dom"
import { get, post } from "../../../helpers/api_helper"
import * as url from "../../../helpers/url_helper"
import cogoToast from "cogo-toast"

import Moment from "moment"
import { extendMoment } from "moment-range"
import { connect } from "react-redux"

const moment = extendMoment(Moment)

const NewActivity = props => {
  const history = useHistory()

  const [freqTab, setFreqTab] = useState(0)

  const [activityName, setActivityName] = useState("")
  const [activityCode, setActivityCode] = useState("")
  const [serviceType, setServiceType] = useState(null)
  const [selectedGroups, setSelectedGroups] = React.useState([])
  const [frequencies, setFrequencies] = useState([
    {
      assets: [],
      startDate: moment().format("YYYY-MM-DD"),
      endDate: moment().add(1, "year").format("YYYY-MM-DD"),
      type: "Daily",
      repeatVal: 1,
      repeatType: "null",
      timeSlots: [],
      weekDays: [false, false, false, false, false, false, false],
      monthDays: [
        false,
        false,
        false,
        false,
        false,
        false,
        false,
        false,
        false,
        false,
        false,
        false,
        false,
        false,
        false,
        false,
        false,
        false,
        false,
        false,
        false,
        false,
        false,
        false,
        false,
        false,
        false,
        false,
        false,
        false,
        false,
      ],
    },
  ])

  const weekVals = ["M", "T", "W", "T", "F", "S", "S"]
  const monthVals = [
    [1, 2, 3, 4, 5, 6, 7],
    [8, 9, 10, 11, 12, 13, 14],
    [15, 16, 17, 18, 19, 20, 21],
    [22, 23, 24, 25, 26, 27, 28],
    [29, 30, 31],
  ]

  const weekDays = [false, false, false, false, false, false, false]
  const monthDays = [
    false,
    false,
    false,
    false,
    false,
    false,
    false,
    false,
    false,
    false,
    false,
    false,
    false,
    false,
    false,
    false,
    false,
    false,
    false,
    false,
    false,
    false,
    false,
    false,
    false,
    false,
    false,
    false,
    false,
    false,
    false,
  ]

  const [assets, setAssets] = React.useState([])
  const [groups, setGroups] = React.useState([])
  const [forms, setForms] = React.useState([])
  const [serviceTypes, setServiceTypes] = useState([])

  const [formId, setFormId] = React.useState(null)
  const [fields, setFields] = React.useState([])
  const [valFields, setValFields] = React.useState([])

  const [selectedAssets, setSelectedAssets] = React.useState([])
  const [allselectedAssets, setAllSelectedAssets] = React.useState([])
  const [selectedAssetIds, setSelectedAssetIds] = React.useState([])
  const [showVal, setShowVal] = useState(false)
  const toggleVal = () => {
    setShowVal(!showVal)
  }
  const [validateThese, setValidateThese] = React.useState([])

  const [errors, setErrors] = React.useState([])

  const [loading, setLoading] = React.useState(true)
  const [initializing, setInitializing] = React.useState(true)
  const [formloading, setFormLoading] = React.useState(false)

  const [modal, setModal] = useState(false)
  const toggle = () => setModal(!modal)

  const [genStart, setGenStart] = useState("08:00:00")
  const [genEnd, setGenEnd] = useState("16:00:00")
  const [genVal, setGenVal] = useState("1")
  const [genUnit, setGenUnit] = useState("hours")
  const [genDurationVal, setGenDurationVal] = useState("1")
  const [genDurationUnit, setGenDurationUnit] = useState("hours")

  const addFreq = () => {
    let temp = JSON.parse(JSON.stringify(frequencies))
    temp.push({
      assets: [],
      startDate: moment().format("YYYY-MM-DD"),
      endDate: moment().add(1, "year").format("YYYY-MM-DD"),
      type: "Daily",
      repeatVal: 1,
      repeatType: "null",
      timeSlots: [],
      weekDays: [false, false, false, false, false, false, false],
      monthDays: [
        false,
        false,
        false,
        false,
        false,
        false,
        false,
        false,
        false,
        false,
        false,
        false,
        false,
        false,
        false,
        false,
        false,
        false,
        false,
        false,
        false,
        false,
        false,
        false,
        false,
        false,
        false,
        false,
        false,
        false,
        false,
      ],
    })
    setFrequencies(temp)
  }

  const deleteFreq = index => {
    let temp = JSON.parse(JSON.stringify(frequencies))
    temp.splice(index, 1)
    if (freqTab == index) {
      setFreqTab(index - 1)
    }
    setFrequencies(temp)
  }

  const recalcAdd = srcAsset => {
    let temp = JSON.parse(JSON.stringify(selectedAssets))
    let tempAll = JSON.parse(JSON.stringify(allselectedAssets))
    let tempIds = JSON.parse(JSON.stringify(selectedAssetIds))
    // console.log(selectedAssets.indexOf(srcAsset), srcAsset, selectedAssets);
    if (selectedAssetIds.indexOf(srcAsset.value) == -1) {
      temp.push({ ...srcAsset, selected: false, validations: null })
      tempIds.push(srcAsset.value)
    }
    tempAll.push({
      ...srcAsset,
      selected: false,
      validations: null,
      freq: freqTab,
    })
    setSelectedAssets(temp)
    setSelectedAssetIds(tempIds)
    setAllSelectedAssets(tempAll)
  }

  const recalcRemove = srcAsset => {
    let tempAll = JSON.parse(JSON.stringify(allselectedAssets))
    let pos = tempAll.findIndex(
      sA => sA.value == srcAsset.value && sA.freq == freqTab
    )
    if (pos !== -1) {
      tempAll.splice(pos, 1)
      let posAll = tempAll.findIndex(
        sA => sA.value == srcAsset.value && sA.freq !== freqTab
      )
      if (posAll == -1) {
        // No other instances exist
        let temp = JSON.parse(JSON.stringify(selectedAssets))
        let tempIds = JSON.parse(JSON.stringify(selectedAssetIds))
        let posId = tempIds.findIndex(sA => sA == srcAsset.value)
        if (posId !== -1) {
          tempIds.splice(posId, 1)
        }
        setSelectedAssetIds(tempIds)
        let posSel = temp.findIndex(sA => sA.value == srcAsset.value)
        if (posSel !== -1) {
          temp.splice(posSel, 1)
        }
        setSelectedAssets(temp)
      }
      setAllSelectedAssets(tempAll)
    }
  }

  const regenSelected = () => {
    let temp = JSON.parse(JSON.stringify(selectedAssets))
    temp.map((tItem, tIdx) => {
      temp[tIdx].validations = null
      // temp[tIdx].selected = false;
    })
    setSelectedAssets(temp)
  }

  const fetchData = id => {
    setLoading(true)
    console.log("Fetching ", id)
    get(url.GET_ACTIVITY + "/" + id)
      .then(response => {
        console.log("fRESP", response)
        // return;

        var boolValue = [false, false, false, false, false, false, false]
        var dateValue = [1, 2, 3, 4, 5, 6, 7]
        var monthBoolValue = []
        var monthValue = []

        for (var i = 0; i < 31; i++) {
          monthValue[i] = i + 1
        }

        for (var i = 0; i < 31; i++) {
          monthBoolValue.push(false)
        }

        console.log("var points", monthValue)
        console.log("month var points", monthBoolValue)

        const dateConversion = data => {
          console.log("days", data)
          data.map(data =>
            data === dateValue[0]
              ? (boolValue[0] = true)
              : data === dateValue[1]
              ? (boolValue[1] = true)
              : data === dateValue[2]
              ? (boolValue[2] = true)
              : data === dateValue[3]
              ? (boolValue[3] = true)
              : data === dateValue[4]
              ? (boolValue[4] = true)
              : data === dateValue[5]
              ? (boolValue[5] = true)
              : data === dateValue[6]
              ? (boolValue[6] = true)
              : boolValue
          )
          // console.log("boolValue", boolValue)

          return boolValue
        }

        const monthConversion = data => {
          data.map(data =>
            data === monthValue[0]
              ? (monthBoolValue[0] = true)
              : data === monthValue[1]
              ? (monthBoolValue[1] = true)
              : data === monthValue[2]
              ? (monthBoolValue[2] = true)
              : data === monthValue[3]
              ? (monthBoolValue[3] = true)
              : data === monthValue[4]
              ? (monthBoolValue[4] = true)
              : data === monthValue[5]
              ? (monthBoolValue[5] = true)
              : data === monthValue[6]
              ? (monthBoolValue[6] = true)
              : data === monthValue[6]
              ? (monthBoolValue[6] = true)
              : data === monthValue[6]
              ? (monthBoolValue[6] = true)
              : data === monthValue[6]
              ? (monthBoolValue[6] = true)
              : data === monthValue[6]
              ? (monthBoolValue[6] = true)
              : data === monthValue[7]
              ? (monthBoolValue[7] = true)
              : data === monthValue[8]
              ? (monthBoolValue[8] = true)
              : data === monthValue[9]
              ? (monthBoolValue[9] = true)
              : data === monthValue[10]
              ? (monthBoolValue[10] = true)
              : data === monthValue[11]
              ? (monthBoolValue[11] = true)
              : data === monthValue[12]
              ? (monthBoolValue[12] = true)
              : data === monthValue[13]
              ? (monthBoolValue[13] = true)
              : data === monthValue[14]
              ? (monthBoolValue[14] = true)
              : data === monthValue[15]
              ? (monthBoolValue[15] = true)
              : data === monthValue[16]
              ? (monthBoolValue[16] = true)
              : data === monthValue[17]
              ? (monthBoolValue[17] = true)
              : data === monthValue[18]
              ? (monthBoolValue[18] = true)
              : data === monthValue[19]
              ? (monthBoolValue[19] = true)
              : data === monthValue[20]
              ? (monthBoolValue[20] = true)
              : data === monthValue[21]
              ? (monthBoolValue[21] = true)
              : data === monthValue[22]
              ? (monthBoolValue[22] = true)
              : data === monthValue[23]
              ? (monthBoolValue[23] = true)
              : data === monthValue[24]
              ? (monthBoolValue[24] = true)
              : data === monthValue[25]
              ? (monthBoolValue[25] = true)
              : data === monthValue[26]
              ? (monthBoolValue[26] = true)
              : data === monthValue[27]
              ? (monthBoolValue[27] = true)
              : data === monthValue[28]
              ? (monthBoolValue[28] = true)
              : data === monthValue[29]
              ? (monthBoolValue[29] = true)
              : data === monthValue[30]
              ? (monthBoolValue[30] = true)
              : monthBoolValue
          )
          // console.log("boolValue", boolValue)

          return monthBoolValue
        }

        if (response.status == 200) {
          if (response.data) {
            let tempFreqs = response.data.frequencies.map(tempFreq => ({
              id: tempFreq.id,
              assets: tempFreq.assets.map(a => ({
                value: a.id,
                label: a.name,
              })),
              startDate: tempFreq.startdate,
              endDate: tempFreq.enddate,
              type: tempFreq.type,
              repeatVal: tempFreq.interval,
              timeSlots: JSON.parse(tempFreq.timeslots),
              weekDays: dateConversion(JSON.parse(tempFreq.daysofweek)),
              monthDays: monthConversion(JSON.parse(tempFreq.daysofmonth)),
            }))

            setActivityName(response.data.name)
            setActivityCode(response.data.activity_code)
            setServiceType({
              value: response.data.servicetype.id,
              label: response.data.servicetype.name,
            })
            setSelectedGroups(
              response.data.groups.map(a => ({ value: a.id, label: a.name }))
            )
            setFrequencies(tempFreqs)

            setFormId({
              value: response.data.form_id,
              label: response.data.form.name,
            })
            fetchForm(response.data.form_id)

            // Validations
            // selectedAssets
            // selectedAssetIds
            // allSelectedAssetIds

            let temp = []
            let tempAll = []
            let tempIds = []

            response.data.frequencies.map((freq, freqIdx) => {
              freq.assets.map(fAsset => {
                tempAll.push({
                  value: fAsset.id,
                  label: fAsset.name,
                  selected: false,
                  validations: null,
                  freq: freqIdx,
                })
                if (tempIds.indexOf(fAsset.id) == -1) {
                  temp.push({
                    value: fAsset.id,
                    label: fAsset.name,
                    selected: false,
                    validations: null,
                  })
                  tempIds.push(fAsset.id)
                }
              })
            })

            if (response.data.validations?.length > 0) {
              response.data.validations.map(val => {
                temp.find(
                  tItem => tItem.value == val.asset_id
                ).validations = JSON.parse(val.data)
                tempAll.find(
                  tItem2 => tItem2.value == val.asset_id
                ).validations = JSON.parse(val.data)
                temp.find(tItem => tItem.value == val.asset_id).validation_id =
                  val.id
                tempAll.find(
                  tItem2 => tItem2.value == val.asset_id
                ).validation_id = val.id
              })
            }

            setSelectedAssetIds(tempIds)
            setSelectedAssets(temp)
            setAllSelectedAssets(tempAll)

            console.log(temp, tempIds, tempAll)

            // let temp = JSON.parse(JSON.stringify(selectedAssets));
            // let tempAll = JSON.parse(JSON.stringify(allselectedAssets));
            // let tempIds = JSON.parse(JSON.stringify(selectedAssetIds));
            // // console.log(selectedAssets.indexOf(srcAsset), srcAsset, selectedAssets);
            // if(selectedAssetIds.indexOf(srcAsset.value) == -1) {
            //   temp.push({...srcAsset, selected: false, validations: null});
            //   tempIds.push(srcAsset.value);
            // }
            // tempAll.push({...srcAsset, selected: false, validations: null, freq: freqTab});
            // setSelectedAssets(temp);
            // setSelectedAssetIds(tempIds);
            // setAllSelectedAssets(tempAll);
          } else {
            cogoToast.error("Could not fetch activity data")
          }
          setLoading(false)
        } else {
          cogoToast.error("Could not fetch activity data")
          setLoading(false)
        }
      })
      .catch(error => {
        console.log("err:", error)
      })
  }

  const init = blockId => {
    setInitializing(true)
    get(url.GET_NEW_ACTIVITY + "/" + blockId.id)
      .then(response => {
        console.log("RESP", response)
        if (response.status == 200) {
          setAssets(response.data.assets)
          setGroups(response.data.groups)
          setForms(response.data.forms)
          setServiceTypes(response.data.servicetypes)

          setInitializing(false)
        } else {
          cogoToast.error("Could not fetch data")
          setInitializing(false)
        }
      })
      .catch(error => {
        console.log("err:", error)
      })
  }

  const fetchForm = id => {
    // console.log('Fetch Form:', id);
    setFormLoading(true)
    get(url.GET_FORM + "/" + id)
      .then(response => {
        console.log("RESP", response)
        if (response.status == 200) {
          setFields(response.data.fields)
          // setForm(response.data.form);
          setFormLoading(false)
        } else {
          console.log("err::", response)
        }
      })
      .catch(error => {
        console.log("err:", error)
      })
  }

  const addRow = () => {
    console.log("adding row")
    let temp = JSON.parse(JSON.stringify(frequencies))
    temp[freqTab].timeSlots.push({
      start: "00:00:00",
      end: "00:30:00",
    })
    setFrequencies(temp)
  }

  const addRows = () => {
    const range = moment.range("2021-01-01 " + genStart, "2021-01-01 " + genEnd)

    let tUnits = null
    if (genUnit == "hours") {
      tUnits = Array.from(range.by("hour", { step: genVal, excludeEnd: false }))
    }
    if (genUnit == "minutes") {
      tUnits = Array.from(
        range.by("minute", { step: genVal, excludeEnd: false })
      )
    }
    // hours.length == 5 // true
    // let newBases = tUnits.map(m => m.format('HH:mm')) // ['00:00', '01:00', '02:00', '03:00', '04:00']

    let newSlots = tUnits.map(base => {
      return {
        start: base.format("HH:mm:ss"),
        end: base.add(genDurationVal, genDurationUnit).format("HH:mm:ss"),
      }
    })

    console.log(newSlots)

    // let newSlots = JSON.parse(JSON.stringify(timeSlots));
    // newSlots.push({
    //   start: "00:00:00",
    //   end: "00:30:00",
    //   });
    let temp = JSON.parse(JSON.stringify(frequencies))
    temp[freqTab].timeSlots = newSlots
    setFrequencies(temp)
    setModal(false)
  }

  const deleteRow = index => {
    let temp = JSON.parse(JSON.stringify(frequencies))
    temp[freqTab].timeSlots.splice(index, 1)
    setFrequencies(temp)
  }

  const handleSubmit = () => {
    if (activityName == "") {
      cogoToast.error("Activity name is required")
      return
    }

    if (formId == null) {
      cogoToast.error("A form should be selected!")
      return
    }

    if (serviceType == null) {
      cogoToast.error("Please select Service type")
      return
    }

    if (!selectedGroups || selectedGroups.length < 1) {
      cogoToast.error("Please select at least one group")
      return
    }

    for (var i = 0; i < frequencies.length; i++) {
      if (!frequencies[i].assets || frequencies[i].assets.length < 1) {
        cogoToast.error("Please choose assets for frequency " + (i + 1))
        return
      }
      if (frequencies[i].timeSlots.length < 1) {
        cogoToast.error("Please add some time slots for frequency " + (i + 1))
        return
      }
    }

    var dateValue = []

    var monthValue = []

    // console.log("var points", monthValue)
    // console.log("month var points", monthBoolValue)

    const dateConversion = data => {
      //console.log("days", data)
      data.map((data, index) =>
        data === true ? dateValue.push(index + 1) : dateValue
      )
      //console.log("dateValue", dateValue)

      return JSON.stringify(dateValue)
    }

    console.log("dateValue outside", dateValue)

    const monthConversion = data => {
      data.map((data, index) =>
        data === true ? monthValue.push(index) : monthValue
      )

      return JSON.stringify(monthValue)
    }

    let freqs = frequencies.map(freq => ({
      id: freq.id || null,
      start_date: freq.startDate,
      end_date: freq.endDate,
      type: freq.type,
      interval: freq.repeatVal,
      assets: freq.assets.map(a => a.value),
      timeslots: JSON.stringify(freq.timeSlots),
      daysofweek: dateConversion(freq.weekDays),
      daysofmonth: monthConversion(freq.monthDays),
    }))

    let data = {
      id: props.match.params.id ? props.match.params.id : "new",
      name: activityName,
      activity_code: activityCode,
      servicetype_id: serviceType.value,
      form_id: formId.value,
      groups: selectedGroups.map(a => a.value),
      frequencies: freqs,
      property_id: props.filterProperty.id,
      block_id: props.filterBlock.id,
    }

    // console.log('selectedAssets', selectedAssets);

    let validations = []
    selectedAssets.map(selAsset => {
      if (selAsset.validations !== null) {
        console.log("selAsset.validations", selAsset.validations)
        validations.push({
          id: selAsset.validation_id || null,
          asset_id: selAsset.value,
          fields: JSON.stringify(
            selAsset.validations.map(sVal => ({
              formfield_id: sVal.id,
              // form_id: sVal.form_id,
              type: sVal.type,
              label: sVal.label,
              min: sVal.min,
              max: sVal.max,
              warning_min: sVal.warning_min,
              warning_max: sVal.warning_max,
              alert_on: sVal.alert_on,
              options: sVal.options,
            }))
          ),
        })
      }
    })

    console.log("Validations", validations)

    data.validations = validations
    console.log("data in activity listing....", data)

    // return;

    setLoading(true)
    setErrors([])
    // axios.post('/api/beacon/create', {
    post(url.POST_NEW_ACTIVITY, data).then(
      response => {
        console.log("RESP", response)
        if (response.status == 200) {
          history.push("/activities/index")
          cogoToast.success(
            "Activity " +
              (props.match.params.id
                ? props.match.params.id == "new"
                  ? "added"
                  : "updated"
                : "added") +
              " successfully"
          )
        } else if (response.status == 400) {
          // setErrors(Object.values(response.error));
        } else {
          console.log("err::", response)
        }
        // if(response == true) {
        // }
        // if(response.status == 200) {
        //   if(response.data == 'input') {
        //     cogoToast.error('Please check your input');
        //     setLoading(false);
        //   }
        //   else if(response.data == 'exists') {
        //     cogoToast.error('Beacon name is already taken');
        //     setLoading(false);
        //   }
        //   else {
        //     props.insertItem(response.data);
        //   }
        // }
        // else {
        //   cogoToast.error('Beacon could not be created');
        //   setLoading(false);
        // }
      },
      error => {
        console.log(error)
        setLoading(false)
      }
    )
  }

  const toggleWeekDay = index => {
    let temp = JSON.parse(JSON.stringify(frequencies))
    temp[freqTab].weekDays[index] = !temp[freqTab].weekDays[index]
    setFrequencies(temp)
  }

  const toggleMonthDay = index => {
    let temp = JSON.parse(JSON.stringify(frequencies))
    temp[freqTab].monthDays[index] = !temp[freqTab].monthDays[index]
    setFrequencies(temp)
  }

  const addValFields = () => {
    console.log(markedAssets, selectedAssets, validateThese)
    let tempSelAssets = JSON.parse(JSON.stringify(selectedAssets))
    validateThese.map(vmAsset => {
      let pos = tempSelAssets.findIndex(sA => sA.value == vmAsset.value)
      if (pos !== -1) {
        tempSelAssets[pos].validations = JSON.parse(JSON.stringify(valFields))
      }
    })
    setSelectedAssets(tempSelAssets)
    setShowVal(false)
  }

  React.useEffect(() => {
    console.log(props.filterBlock)
    if (props.filterBlock) {
      let temp = JSON.parse(JSON.stringify(frequencies))
      temp.map(t => {
        t.assets = []
      })
      setFrequencies(temp)
      setSelectedAssetIds([])
      setSelectedAssets([])
      setAllSelectedAssets([])
      setFormId(null)
      setSelectedGroups([])

      init(props.filterBlock)
    }
  }, [props.filterBlock])

  React.useEffect(() => {
    if (props.match.params.id && props.match.params.id !== "new") {
      fetchData(props.match.params.id)
    }
  }, [])

  const markedAssets = selectedAssets.filter(a => a.selected)
  const dispGroups = serviceType
    ? groups.filter(b => b.servicetype_id == serviceType.value)
    : []

  // console.log('dispGroups', serviceType, groups, dispGroups, selectedGroups);

  return (
    <React.Fragment>
      <div className="page-content">
        <MetaTags>
          <title>
            {props.match.params.id
              ? props.match.params.id == "new"
                ? "Add New"
                : "Edit"
              : "Add New"}{" "}
            Activity | Digital Logbook
          </title>
        </MetaTags>
        <Container fluid>
          <div className="d-flex justify-content-between align-items-center">
            <h3 className="mb-4">
              {props.match.params.id
                ? props.match.params.id == "new"
                  ? "New"
                  : "Edit"
                : "New"}{" "}
              Activity
            </h3>
            <Link className="btn btn-secondary" to="/activities/index">
              Back
            </Link>
          </div>

          {errors.length > 0 && (
            <div className="mt-3 mb-5">
              {errors.map((error, errorIdx) => (
                <Alert key={errorIdx} color="danger">
                  <i className="mdi mdi-alert-circle-outline me-2"></i>
                  {error}
                </Alert>
              ))}
            </div>
          )}

          <Card>
            <CardBody>
              {/* <CardTitle tag="h3">BASIC DETAILS</CardTitle> */}
              {/* <CardSubtitle tag="h5" className="mb-4 text-muted">22 Jul 2021</CardSubtitle> */}
              <div className="row mt-2">
                <div className="col">
                  <div className="mb-4 row">
                    <label
                      htmlFor="activityName"
                      className="col-sm-3 col-form-label label-required"
                    >
                      Activity Name
                    </label>
                    <div className="col-sm-9">
                      <input
                        autoFocus
                        type="text"
                        className="form-control"
                        id="activityName"
                        value={activityName}
                        onChange={e => {
                          setActivityName(e.target.value)
                        }}
                      />
                    </div>
                  </div>
                  <div className="mb-4 row">
                    <label
                      htmlFor="activityCode"
                      className="col-sm-3 col-form-label label-required"
                    >
                      Activity Code
                    </label>
                    <div className="col-sm-9">
                      <input
                        type="text"
                        className="form-control"
                        id="activityCode"
                        value={activityCode}
                        onChange={e => {
                          setActivityCode(e.target.value)
                        }}
                      />
                    </div>
                  </div>
                  <div className="mb-4 row">
                    <label
                      htmlFor="property"
                      className="col-sm-3 col-form-label label-required"
                    >
                      Property
                    </label>
                    <div className="col-sm-9">
                      <span
                        className={
                          props.filterProperty && props.filterBlock
                            ? "text-success"
                            : "text-danger"
                        }
                      >
                        {props.filterProperty && props.filterBlock
                          ? props.filterProperty.name +
                            " / " +
                            props.filterBlock.name
                          : "Please select"}
                      </span>
                    </div>
                  </div>
                  <div className="mb-4 row">
                    <label
                      htmlFor="serviceType"
                      className="col-sm-3 col-form-label label-required"
                    >
                      Activity Type
                    </label>
                    <div className="col-sm-9">
                      <Select
                        classNamePrefix="select2-selection"
                        placeholder="Select one.."
                        title="Activity Type"
                        options={serviceTypes}
                        value={serviceType}
                        onChange={e => {
                          setServiceType(e)
                          setSelectedGroups([])
                        }}
                      />
                    </div>
                  </div>

                  <div className="mb-4 row">
                    <label
                      htmlFor="inputPassword"
                      className="col-sm-3 col-form-label label-required"
                    >
                      Assign to
                    </label>
                    <div className="col-sm-9">
                      {/* <input type="text" className="form-control" id="inputPassword" /> */}
                      {/* <input className="form-control" list="datalistOptions" id="exampleDataList" placeholder="Type to search..." /> */}
                      <Select
                        classNamePrefix="select2-selection"
                        placeholder="Choose..."
                        title="Groups"
                        options={dispGroups}
                        isMulti
                        value={selectedGroups}
                        onChange={e => {
                          setSelectedGroups(e)
                        }}
                      />
                    </div>
                  </div>

                  {/* <div className="mb-4 row">
                    <label htmlFor="status" className="col-sm-3 col-form-label">Status</label>
                    <div className="col-sm-9">
                      <select className="form-control" placeholder="Select one" 
                        value={status}
                        onChange={(e)=>{ setStatus(e.target.value); }}
                        >
                        <option value="1">Active</option>
                        <option value="0">Inactive</option>
                      </select>
                    </div>
                  </div> */}
                </div>
              </div>
            </CardBody>
          </Card>

          <Card>
            <CardBody>
              <CardTitle tag="h3">SCHEDULE</CardTitle>
              {/* <CardSubtitle tag="h5" className="mb-4 text-muted">22 Jul 2021</CardSubtitle> */}

              <div className="d-flex flex-row w100 mt-4 w-100 flex-wrap">
                {frequencies.map((freq, freqIdx) => (
                  <div
                    className="border border-secondary px-3 py-1 d-flex freq-tab"
                    key={freqIdx}
                    style={{
                      backgroundColor: freqIdx == freqTab ? "#ccc" : "#fff",
                    }}
                  >
                    <div
                      onClick={() => {
                        setFreqTab(freqIdx)
                        console.log(frequencies)
                      }}
                    >
                      Frequency {freqIdx + 1}
                    </div>
                    {freqIdx > 0 && (
                      <div
                        onClick={() => {
                          deleteFreq(freqIdx)
                        }}
                        className="freq-tab-close"
                      >
                        x
                      </div>
                    )}
                  </div>
                ))}
                <div
                  onClick={() => {
                    addFreq()
                  }}
                  className="border border-secondary px-4 py-1 freq-tab"
                >
                  + Add one
                </div>
              </div>

              <div className="freq-wrapper p-3">
                <div className="">
                  <div className="mb-4 row">
                    <label
                      htmlFor="inputPassword"
                      className="col-sm-3 col-form-label"
                    >
                      Assets
                    </label>
                    <div className="col-sm-9">
                      {/* <input type="text" className="form-control" id="inputPassword" /> */}
                      {/* <input className="form-control" list="datalistOptions" id="exampleDataList" placeholder="Type to search..." /> */}
                      <Select
                        classNamePrefix="select2-selection"
                        placeholder="Choose..."
                        title="Assets"
                        options={assets}
                        isMulti
                        noOptionsMessage={() => "No assets found"}
                        value={frequencies[freqTab]?.assets}
                        onChange={(e, newVal) => {
                          console.log("second arg", newVal)
                          let temp = JSON.parse(JSON.stringify(frequencies))
                          temp[freqTab].assets = e
                          setFrequencies(temp)

                          // console.log('clicked', e, selectedAssets, selectedAssets.indexOf(e));
                          if (newVal.action == "select-option") {
                            recalcAdd(newVal.option)
                          } else if (newVal.action == "remove-value") {
                            recalcRemove(newVal.removedValue)
                          }
                          // if(selectedAssets.indexOf(e) == -1) {
                          //   selectedAssets.push(e);
                          // }
                        }}
                      />
                    </div>
                  </div>

                  <div className="mb-4 row">
                    <label
                      htmlFor="staticEmail"
                      className="col-sm-3 col-form-label"
                    >
                      Start date
                    </label>
                    <div className="col-sm-9">
                      <input
                        type="text"
                        className="form-control"
                        id="inputPassword"
                        type="date"
                        // defaultValue="2019-08-19"
                        value={frequencies[freqTab]?.startDate}
                        onChange={e => {
                          let temp = JSON.parse(JSON.stringify(frequencies))
                          temp[freqTab].startDate = e.target.value
                          setFrequencies(temp)
                        }}
                      />
                    </div>
                  </div>
                  <div className="mb-4 row">
                    <label
                      htmlFor="staticEmail"
                      className="col-sm-3 col-form-label"
                    >
                      End date
                    </label>
                    <div className="col-sm-9">
                      <input
                        type="text"
                        className="form-control"
                        id="inputPassword"
                        type="date"
                        // defaultValue="2019-08-19"
                        value={frequencies[freqTab]?.endDate}
                        onChange={e => {
                          let temp = JSON.parse(JSON.stringify(frequencies))
                          temp[freqTab].endDate = e.target.value
                          setFrequencies(temp)
                        }}
                      />
                    </div>
                  </div>

                  <div className="mb-4 row">
                    <label
                      htmlFor="staticEmail"
                      className="col-sm-3 col-form-label"
                    >
                      Time Slots
                    </label>
                    <div className="col-sm-9">
                      <div className="">
                        {frequencies[freqTab]?.timeSlots.length > 0 ? (
                          <div className="d-flex flex-row flex-wrap">
                            {frequencies[freqTab]?.timeSlots.map(
                              (slot, slotIdx) => (
                                <div
                                  key={slotIdx}
                                  className="border border-light border-2 rounded px-3 py-2 me-2 mb-2"
                                >
                                  <div className="text-right d-flex justify-content-end mb-2">
                                    <button
                                      disabled={slotIdx == 0}
                                      type="button"
                                      className={
                                        "btn-close" +
                                        (slotIdx == 0 ? " opacity-0" : "")
                                      }
                                      aria-label="Close"
                                      onClick={() => {
                                        deleteRow(slotIdx)
                                      }}
                                    ></button>
                                  </div>
                                  <input
                                    className="form-control"
                                    style={{ width: "auto" }}
                                    id="inputPassword"
                                    type="time"
                                    value={slot.start}
                                    onChange={e => {
                                      let temp = JSON.parse(
                                        JSON.stringify(frequencies)
                                      )
                                      temp[freqTab].timeSlots[slotIdx].start =
                                        e.target.value
                                      setFrequencies(temp)
                                    }}
                                  />
                                  <div className="text-center py-1">to</div>
                                  <input
                                    className="form-control"
                                    style={{ width: "auto" }}
                                    id="inputPassword"
                                    type="time"
                                    value={slot.end}
                                    onChange={e => {
                                      let temp = JSON.parse(
                                        JSON.stringify(frequencies)
                                      )
                                      temp[freqTab].timeSlots[slotIdx].end =
                                        e.target.value
                                      setFrequencies(temp)
                                    }}
                                  />
                                </div>
                              )
                            )}
                          </div>
                        ) : (
                          <div className="text-muted">No Slots</div>
                        )}
                        <hr />

                        <div className="d-flex justify-content-between align-items-center w-100">
                          <button
                            type="button"
                            className="btn btn-primary me-2"
                            onClick={() => {
                              addRow()
                            }}
                          >
                            Add One
                          </button>
                          <div className="d-flex justify-content-end align-items-center">
                            <button
                              type="button"
                              className="btn btn-secondary me-2"
                              onClick={() => {
                                toggle()
                              }}
                            >
                              Generate
                            </button>
                            <button
                              type="button"
                              className="btn btn-danger me-2"
                              onClick={() => {
                                let temp = JSON.parse(
                                  JSON.stringify(frequencies)
                                )
                                temp[freqTab].timeSlots = []
                                setFrequencies(temp)
                              }}
                            >
                              Clear
                            </button>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div className="mb-4 row">
                    <label
                      htmlFor="staticEmail"
                      className="col-sm-3 col-form-label"
                    >
                      Frequency type
                    </label>
                    <div className="col-sm-9">
                      {/* <input type="text" className="form-control" id="inputPassword" /> */}
                      <select
                        className="form-control"
                        placeholder="Select"
                        value={frequencies[freqTab]?.type}
                        onChange={e => {
                          let temp = JSON.parse(JSON.stringify(frequencies))
                          temp[freqTab].type = e.target.value
                          setFrequencies(temp)
                        }}
                      >
                        <option value="Daily">Daily</option>
                        <option value="Weekly">Weekly</option>
                        <option value="Monthly">Monthly</option>
                      </select>
                      {frequencies[freqTab]?.type == "Weekly" && (
                        <div className="row pt-4">
                          {weekVals.map((weekVal, weekValIdx) => (
                            <div className="col-1" key={weekValIdx}>
                              <Button
                                outline={
                                  !frequencies[freqTab]?.weekDays[weekValIdx]
                                }
                                color="primary"
                                onClick={() => {
                                  toggleWeekDay(weekValIdx)
                                }}
                              >
                                {weekVal}
                              </Button>
                            </div>
                          ))}
                        </div>
                      )}
                      {frequencies[freqTab]?.type == "Monthly" && (
                        <div>
                          {monthVals.map((monthRow, monthRowIdx) => (
                            <div className="row pt-4" key={monthRowIdx}>
                              {monthRow.map((monthCol, monthColIdx) => (
                                <div className="col-1" key={monthColIdx}>
                                  <Button
                                    outline={
                                      !frequencies[freqTab]?.monthDays[
                                        monthCol - 1
                                      ]
                                    }
                                    color="primary"
                                    onClick={() => {
                                      toggleMonthDay(monthCol - 1)
                                    }}
                                  >
                                    {monthCol}
                                  </Button>
                                </div>
                              ))}
                            </div>
                          ))}
                        </div>
                      )}
                    </div>
                  </div>

                  <div className="mb-4 row">
                    <label
                      htmlFor="staticEmail"
                      className="col-sm-3 col-form-label"
                    >
                      Repeat
                    </label>
                    <div className="col-sm-9">
                      <div className="d-flex align-items-center">
                        <input
                          type="text"
                          className="form-control"
                          style={{ width: "auto" }}
                          id="inputPassword"
                          type="number"
                          min={1}
                          // defaultValue="2019-08-19"
                          value={frequencies[freqTab]?.repeatVal}
                          onChange={e => {
                            let temp = JSON.parse(JSON.stringify(frequencies))
                            temp[freqTab].repeatVal = e.target.value
                            setFrequencies(temp)
                          }}
                        />
                        <div className="ps-2">
                          {frequencies[freqTab]?.type == "Daily"
                            ? "days"
                            : frequencies[freqTab]?.type == "Weekly"
                            ? "weeks"
                            : "months"}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </CardBody>
          </Card>

          <Card>
            <CardBody>
              <CardTitle tag="h3">FORM</CardTitle>
              {/* <CardSubtitle tag="h5" className="mb-4 text-muted">22 Jul 2021</CardSubtitle> */}
              <div className="mt-4">
                {/* <label htmlFor="inputPassword" className="col-sm-3 col-form-label">Building Code</label> */}
                {/* <input type="text" className="form-control" id="inputPassword" placeholder="Select one.." /> */}

                <Select
                  classNamePrefix="select2-selection"
                  placeholder="Choose..."
                  title="Form"
                  options={forms}
                  // isMulti
                  value={formId}
                  onChange={e => {
                    setFormId(e)
                    fetchForm(e.value)
                    regenSelected()
                  }}
                  noOptionsMessage={() => "No forms found"}
                />
              </div>
              {formId && fields.length > 0 && (
                <div className="mt-4">
                  <Card outline color="primary" className="border">
                    {/* <CardHeader className="bg-transparent">
          <h5 className="my-0 text-primary">
            <i className="mdi mdi-bullseye-arrow me-3" />Form Preview
          </h5>
        </CardHeader> */}
                    <CardBody>
                      <CardTitle className="mt-0">Preview</CardTitle>
                      <Table className="table table-bordered mb-0">
                        <thead>
                          <tr>
                            <th colSpan="2">Field</th>
                            <th>Field Lower limit</th>
                            <th>Field Upper limit</th>
                            <th>Warning Lower limit</th>
                            <th>Warning Upper limit</th>
                            <th>Alert on</th>
                          </tr>
                        </thead>
                        <tbody>
                          {fields.map((field, fieldIdx) => (
                            <tr key={fieldIdx}>
                              {/* <th scope="row">{fieldIdx+1}</th> */}
                              <td>{field.label}</td>
                              <td>
                                {field.type == "text" ? (
                                  <input className="form-control" type="text" />
                                ) : field.type == "number" ? (
                                  <input
                                    className="form-control"
                                    type="number"
                                  />
                                ) : field.type == "textarea" ? (
                                  <textarea
                                    className="form-control"
                                    rows={4}
                                  ></textarea>
                                ) : field.type == "remark" ? (
                                  <textarea
                                    className="form-control"
                                    rows={4}
                                  ></textarea>
                                ) : field.type == "radio" ? (
                                  <div className="">
                                    {field.options
                                      ?.split(",")
                                      ?.map((opt, optIndex) => (
                                        <div
                                          className="form-check mb-2"
                                          key={optIndex}
                                        >
                                          <input
                                            className="form-check-input"
                                            type="radio"
                                            value={opt}
                                          />
                                          <label className="form-check-label">
                                            {opt}
                                          </label>
                                        </div>
                                      ))}
                                  </div>
                                ) : (
                                  field.type
                                )}
                              </td>
                              <td>{field.min}</td>
                              <td>{field.max}</td>
                              <td>{field.warning_min}</td>
                              <td>{field.warning_max}</td>
                              <td>
                                {field.alert_on == "null" ? "" : field.alert_on}
                              </td>
                            </tr>
                          ))}
                        </tbody>
                      </Table>
                    </CardBody>
                  </Card>
                </div>
              )}
            </CardBody>
          </Card>

          {formId !== null && (
            <Card>
              <CardBody>
                <CardTitle tag="h3">CUSTOM VALIDATIONS</CardTitle>
                {/* <CardSubtitle tag="h5" className="mb-4 text-muted">22 Jul 2021</CardSubtitle> */}
                {selectedAssetIds.length > 0 ? (
                  <div>
                    <table className="table table-striped mt-4">
                      <thead>
                        <tr>
                          <th> </th>
                          <th>Asset</th>
                          <th>Validations</th>
                          <th></th>
                          {/* <th>Field max</th>
                      <th>Warning min</th>
                      <th>Warning max</th>
                      <th>Alert on</th> */}
                        </tr>
                      </thead>
                      <tbody>
                        {selectedAssets.map((mAsset, mAssetIdx) => (
                          <tr key={mAssetIdx}>
                            <td>
                              <input
                                type="checkbox"
                                value={mAsset.selected}
                                onClick={e => {
                                  let temp = JSON.parse(
                                    JSON.stringify(selectedAssets)
                                  )
                                  temp[mAssetIdx].selected = !temp[mAssetIdx]
                                    .selected
                                  setSelectedAssets(temp)
                                }}
                              />
                            </td>
                            <td>{mAsset.label}</td>
                            <td>
                              {mAsset.validations == null
                                ? "Form default"
                                : "Custom"}
                            </td>
                            <td>
                              <button
                                type="button"
                                className="btn btn-link"
                                onClick={() => {
                                  setValidateThese([mAsset])
                                  if (mAsset.validations == null) {
                                    let temp = JSON.parse(
                                      JSON.stringify(fields)
                                    )
                                    temp.map((tf, tfIdx) => {
                                      if (tf.type == "radio") {
                                        temp[tfIdx].fieldOptions =
                                          tf.options?.split(",") || []
                                      }
                                    })
                                    setValFields(temp)
                                  } else {
                                    console.log("mAsset", mAsset)

                                    let temp = JSON.parse(
                                      JSON.stringify(mAsset.validations)
                                    )
                                    temp.map((tf, tfIdx) => {
                                      // console.log('tf', tf, tf.options.split(','));
                                      if (
                                        tf.type == "radio" &&
                                        tf.options.trim() !== ""
                                      ) {
                                        temp[
                                          tfIdx
                                        ].fieldOptions = tf.options.split(",")
                                      }
                                    })
                                    setValFields(temp)
                                  }
                                  toggleVal()
                                }}
                              >
                                {mAsset.validations == null ? "Add" : "Edit"}
                              </button>

                              {mAsset.validations !== null && (
                                <button
                                  type="button"
                                  className="btn btn-link"
                                  onClick={() => {
                                    let temp = JSON.parse(
                                      JSON.stringify(selectedAssets)
                                    )
                                    temp[mAssetIdx].validations = null
                                    setSelectedAssets(temp)
                                  }}
                                >
                                  Remove
                                </button>
                              )}
                            </td>
                            {/* <td>-</td>
                        <td>-</td>
                        <td>-</td>
                        <td>-</td>
                        <td>-</td> */}
                          </tr>
                        ))}
                      </tbody>
                    </table>
                    <div className="text-center mt-3 mb-4">
                      <button
                        type="button"
                        className="btn btn-primary me-3"
                        onClick={() => {
                          setValidateThese(selectedAssets)
                          let temp = JSON.parse(JSON.stringify(fields))
                          temp.map((tf, tfIdx) => {
                            if (tf.type == "radio") {
                              temp[tfIdx].fieldOptions =
                                tf.options?.split(",") || []
                            }
                          })
                          setValFields(temp)
                          toggleVal()
                        }}
                      >
                        Add for all
                      </button>
                      <button
                        type="button"
                        className="btn btn-secondary ms-3"
                        disabled={markedAssets.length < 1}
                        onClick={() => {
                          setValidateThese(markedAssets)
                          let temp = JSON.parse(JSON.stringify(fields))
                          temp.map((tf, tfIdx) => {
                            if (tf.type == "radio") {
                              temp[tfIdx].fieldOptions =
                                tf.options?.split(",") || []
                            }
                          })
                          setValFields(temp)
                          toggleVal()
                        }}
                      >
                        Add for selected
                      </button>
                    </div>
                  </div>
                ) : (
                  <div className="text-muted py-3">No assets added</div>
                )}
              </CardBody>
            </Card>
          )}
        </Container>

        <div className="mb-4 container">
          <div className="d-flex justify-content-center">
            <button
              type="button"
              className="btn btn-primary me-2"
              onClick={() => {
                handleSubmit()
              }}
              disabled={!props.filterBlock}
            >
              Submit
            </button>
            <Link className="btn btn-light" to="/activities/index">
              Cancel
            </Link>
          </div>
        </div>
      </div>

      <Modal isOpen={modal} toggle={toggle} size="lg" className="">
        <ModalHeader toggle={toggle}>Generate Time slots</ModalHeader>
        <ModalBody>
          <div className="mb-4 row">
            <label
              htmlFor="parentAssetCode"
              className="col-sm-3 col-form-label"
            >
              Start Time
            </label>
            <div className="col-sm-9">
              <input
                className="form-control"
                style={{ width: "auto" }}
                id="inputPassword"
                type="time"
                value={genStart}
                onChange={e => {
                  setGenStart(e.target.value)
                }}
              />
            </div>
          </div>
          <div className="mb-4 row">
            <label
              htmlFor="parentAssetCode"
              className="col-sm-3 col-form-label"
            >
              End Time
            </label>
            <div className="col-sm-9">
              <input
                className="form-control"
                style={{ width: "auto" }}
                id="inputPassword"
                type="time"
                value={genEnd}
                onChange={e => {
                  setGenEnd(e.target.value)
                }}
              />
            </div>
          </div>
          <div className="mb-4 row">
            <div className="col-sm-3 col-form-label">
              <label htmlFor="parentAssetCode">Repeat</label>
            </div>
            <div className="col-sm-9 row">
              <div className="col-sm-6">
                <input
                  className="form-control"
                  style={{ width: "auto" }}
                  id="inputPassword"
                  type="number"
                  min={1}
                  value={genVal}
                  onChange={e => {
                    setGenVal(e.target.value)
                  }}
                />
              </div>
              <div className="col-sm-6">
                <select
                  className="form-control"
                  placeholder="Select"
                  value={genUnit}
                  onChange={e => {
                    setGenUnit(e.target.value)
                  }}
                >
                  <option value="hours">Hours</option>
                  <option value="minutes">Minutes</option>
                </select>
              </div>
            </div>
          </div>

          <div className="mb-4 row">
            <div className="col-sm-3 col-form-label">
              <label htmlFor="parentAssetCode">Task Duration</label>
            </div>
            <div className="col-sm-9 row">
              <div className="col-sm-6">
                <input
                  className="form-control"
                  style={{ width: "auto" }}
                  id="inputPassword"
                  type="number"
                  min={1}
                  value={genDurationVal}
                  onChange={e => {
                    setGenDurationVal(e.target.value)
                  }}
                />
              </div>
              <div className="col-sm-6">
                <select
                  className="form-control"
                  placeholder="Select"
                  value={genDurationUnit}
                  onChange={e => {
                    setGenDurationUnit(e.target.value)
                  }}
                >
                  <option value="hours">Hours</option>
                  <option value="minutes">Minutes</option>
                </select>
              </div>
            </div>
          </div>
        </ModalBody>
        <ModalFooter>
          <Button color="primary" onClick={addRows}>
            Generate
          </Button>{" "}
          <Button color="secondary" onClick={toggle}>
            Close
          </Button>
        </ModalFooter>
      </Modal>

      <Modal isOpen={showVal} toggle={toggleVal} size="xl" className="">
        <ModalHeader toggle={toggleVal}>
          Add custom parameter validations
        </ModalHeader>
        <ModalBody>
          <div className="fw-bolder mb-2">Assets</div>
          <div className="border border-secondary">
            {validateThese.map((vAsset, vAssetIdx) => (
              <div key={vAssetIdx}>{vAsset.label}</div>
            ))}
          </div>

          {/* <div className="border border-secondary my-4">
            {JSON.stringify(fields)}
          </div> */}

          <div className="fw-bolder mt-4 mb-2">Validations</div>
          <div
            className="border border-success"
            style={{ width: "100%", overflow: "hidden" }}
          >
            <table className="table table-striped border border-secondary">
              <thead>
                <tr>
                  <th>Field</th>
                  <th>Field lower limit</th>
                  <th>Field upper limit</th>
                  <th>Warning lower limit</th>
                  <th>Warning upper limit</th>
                  <th>Alert on</th>
                </tr>
              </thead>
              <tbody>
                {valFields.map((field, fieldIdx) => (
                  <tr key={fieldIdx}>
                    <td>{field.label}</td>
                    <td>
                      {field.type == "number" ? (
                        <input
                          type="number"
                          placeholder=""
                          className="form-control"
                          id="inputPassword"
                          // disabled={(field.type == 'radio') || (field.type == 'remark')}
                          value={field.min}
                          onChange={e => {
                            let tempArr = JSON.parse(JSON.stringify(valFields))
                            tempArr[fieldIdx].min = e.target.value
                            setValFields(tempArr)
                          }}
                        />
                      ) : (
                        <div>-</div>
                      )}
                    </td>
                    <td>
                      {field.type == "number" ? (
                        <input
                          type="number"
                          placeholder=""
                          className="form-control"
                          id="inputPassword"
                          value={field.max}
                          onChange={e => {
                            let tempArr = JSON.parse(JSON.stringify(valFields))
                            tempArr[fieldIdx].max = e.target.value
                            setValFields(tempArr)
                          }}
                        />
                      ) : (
                        <div>-</div>
                      )}
                    </td>
                    <td>
                      {field.type == "number" ? (
                        <input
                          type="number"
                          placeholder=""
                          className="form-control"
                          id="inputPassword"
                          value={field.warning_min}
                          onChange={e => {
                            let tempArr = JSON.parse(JSON.stringify(valFields))
                            tempArr[fieldIdx].warning_min = e.target.value
                            setValFields(tempArr)
                          }}
                        />
                      ) : (
                        <div>-</div>
                      )}
                    </td>
                    <td>
                      {field.type == "number" ? (
                        <input
                          type="number"
                          placeholder=""
                          className="form-control"
                          id="inputPassword"
                          value={field.warning_max}
                          onChange={e => {
                            let tempArr = JSON.parse(JSON.stringify(valFields))
                            tempArr[fieldIdx].warning_max = e.target.value
                            setValFields(tempArr)
                          }}
                        />
                      ) : (
                        <div>-</div>
                      )}
                    </td>
                    <td>
                      {field.type == "number" && (
                        <select
                          className="form-control"
                          placeholder="Type"
                          value={field.alert_on || ""}
                          onChange={e => {
                            let tempArr = JSON.parse(JSON.stringify(valFields))
                            tempArr[fieldIdx].alert_on = e.target.value
                            setValFields(tempArr)
                          }}
                        >
                          <option value="">No alert</option>
                          <option value="warning_max">Warning Max</option>
                          <option value="warning_min">Warning Min</option>
                          <option value="both">Both</option>
                        </select>
                      )}

                      {field.type == "radio" && (
                        <select
                          className="form-control"
                          value={field.alert_on || ""}
                          onChange={e => {
                            let tempArr = JSON.parse(JSON.stringify(valFields))
                            tempArr[fieldIdx].alert_on = e.target.value
                            setValFields(tempArr)
                          }}
                        >
                          <option value="">No alert</option>
                          {field.fieldOptions.map((opt, optIndex) => (
                            <option key={optIndex} value={opt}>
                              {opt}
                            </option>
                          ))}
                        </select>
                      )}
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </ModalBody>
        <ModalFooter>
          <Button color="primary" onClick={addValFields}>
            Add
          </Button>{" "}
          <Button color="secondary" onClick={toggleVal}>
            Cancel
          </Button>
        </ModalFooter>
      </Modal>
    </React.Fragment>
  )
}

const mapStatetoProps = state => {
  const { filterBlock, filterProperty } = state.filters
  return { filterBlock, filterProperty }
}

export default connect(mapStatetoProps)(NewActivity)
